
import { computed, defineComponent, reactive } from 'vue';
import SelecionarOrigemMercadoria from '../SelecionarOrigemMercadoria.vue';
import { ICenarioFiscalDefinicao } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/ICenarioFiscal';
import SelecionarCodigoEnquadramentoIpi from '../SelecionarCodigoEnquadramentoIpi.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarCstIpi from '../SelecionarCstIpi.vue';
import SelecionarTipoCalculoImposto from '../SelecionarTipoCalculoImposto.vue';
import CenarioFiscalInformacaoComplementar from './CenarioFiscalInformacaoComplementar.vue';

export default defineComponent({
  name: 'CenarioFiscalDefinicaoIpi',
  props: {
    definicao: {
      type: Object as () => ICenarioFiscalDefinicao,
      required: true,
    },
  },
  components: {
    SelecionarOrigemMercadoria,
    SelecionarCodigoEnquadramentoIpi,
    CampoNumerico,
    SelecionarCstIpi,
    SelecionarTipoCalculoImposto,
    CenarioFiscalInformacaoComplementar,
  },
  emits: ['update:definicao'],
  setup(props, { emit }) {
    const state = reactive({
    });

    const computedDefinicao = computed({
      get: () => props.definicao,
      set: (definicao: ICenarioFiscalDefinicao) => {
        emit('update:definicao', definicao);
      },
    });

    return {
      props,
      state,
      computedDefinicao,
    };
  },
});
